import { useState } from "react";
import KeyPyramidChart from "./keypyramid";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import DownloadOutlinedIcon from '@mui/icons-material/DownloadOutlined';

import IncidentChart from "./incidentChart";
import { blackdownload, infogrey } from "../utils/safetysvgs/safetysvg";
const Incidents = () => {
      const options = ["Pyramid", "Table"];
         const option = ["Incidents", "Per 10k Hours"];
      const [selectedOption, setSelectedOption] = useState("Pyramid");
          const [selectedIncidentsOption, setSelectedIncidentsOption] = useState("Incidents");
    
      const pyramidData = [
        { label: "Fatal", value: 0, status: "Severe" },
        { label: "Lost-Time", value: 0, status: "Severe" },
        { label: "Recordable", value: 0, status: "Moderate" },
        { label: "FAP", value: 3, status: "Moderate" },
        { label: "PSI", value: 2, status: "Moderate" },
        { label: "First Aids", value: 10, status: "Minor" },
        { label: "Near Misses", value: 6, status: "Minor" },
        { label: "At-Risk", value: 312, status: "Minor" },
      ];
  return (
    <div className="flex flex-col md:flex-row gap-4 p-4 h-screen bg-gray-100">
         <div className="flex-1 rounded-[12.75px] border border-2 border-[rgba(0,0,0,0.10)] bg-white p-4 shadow-sm">
        {/* Header Row */}
        <div className="flex justify-between items-center flex-wrap gap-2">
          <div className="flex items-center gap-2">
            <h2 className="text-base font-semibold text-start text-[#0A0A0A]">Injury Pyramid</h2>
               {infogrey}
          </div>
          <div className="flex rounded-[12.75px] bg-[#DBEAFE] p-1">
            {options.map((label) => {
              const isSelected = selectedOption === label;
              return (
                <button
                  key={label}
                  onClick={() => setSelectedOption(label)}
                  className={`px-3 py-1 text-sm font-medium rounded-[12.75px] transition-colors duration-200 ${
                    isSelected ? "bg-white text-[#0A0A0A]" : "bg-transparent text-[#0A0A0A]"
                  }`}
                >
                  {label}
                </button>
              );
            })}
          </div>
        </div>

        {selectedOption === "Pyramid" && <KeyPyramidChart data={pyramidData} />}
        {/* You can add the table rendering here for "Table" selection */}
      </div>

     <div className="flex-1 rounded-[12.75px] border border-2 border-[rgba(0,0,0,0.10)] bg-white p-4 shadow-sm">
<div className="flex justify-between items-center flex-wrap gap-2">
  <div className="flex w-full justify-between items-start">
    <div>
      <h2 className="text-base font-normal text-start text-[#0A0A0A]">Facility Comparison</h2>
      <p className="text-sm font-normal text-[#717182]">Incidents by location with manhour data</p>
    </div>

    <div className="flex items-center gap-1 rounded-[6.75px] border border-[rgba(0,0,0,0.10)] bg-[#FFF] px-4 py-1 text-sm text-[#0A0A0A] hover:shadow-sm cursor-pointer">
     {blackdownload}
      <span>Export</span>
    </div>
  </div>
         <div className="flex rounded-[12.75px] bg-[#DBEAFE] p-1">
            {option.map((label) => {
              const isSelected = selectedIncidentsOption === label;
              return (
                <button
                  key={label}
                  onClick={() => setSelectedIncidentsOption(label)}
                  className={`px-3 py-1 text-sm font-medium rounded-[12.75px] transition-colors duration-200 ${
                    isSelected ? "bg-white text-[#0A0A0A]" : "bg-transparent text-[#0A0A0A]"
                  }`}
                >
                  {label}
                </button>
              );
            })}
          </div>

<IncidentChart/>
</div>



      </div>
    </div>
  );
};

export default Incidents;
